import React from 'react';

const Reviews = () => {
    return (
        <div>
            <h1>Reviews is comming Soon</h1>
        </div>
    );
};

export default Reviews;